import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { IdService } from "../shared/services/id.service";

import { IGenericSelectOption } from "../shared/types/forms";
import { FormGroup, FormControl, AbstractControl } from "@angular/forms";

export interface PaginatorEvent {
	pageNumber: number;
}

export interface PageSizeEvent {
	currentPage: number;
	pageSize: number;
}

@Component({
	selector: "rbc-paginator",
	templateUrl: "./paginator.component.html",
	styles: []
})
export class PaginatorComponent implements OnInit {
	@Input() totalPages: number;
	@Input() locale = {
		paginationDisplayLabel: "Display",
		paginationPreviousLabel: "Prev",
		paginationNextLabel: "Next",
		paginationFirstLabel: "First page",
		paginationLastLabel: "Last page"
	};
	@Input() paginationDisplay = [5, 10, 30, 50];
	@Input() paginationDisplayPreselected;
	@Input()
	set activePage(activePage: number) {

		if (activePage && activePage > 0 && activePage <= this.totalPages) {
			this._activePage = activePage > 0 ? activePage : 1;
		} else {
			this._activePage = 1;
		}

		setTimeout(() => {
			this.$_Paginator_onPageNumberButtonClicked(this._activePage);

		});

	}
	get activePage() {
		return this._activePage;
	}

	@Input() id: String;
	@Input() displaySelect: boolean = true;
	@Output()
	onPaginatorButtonClicked = new EventEmitter<PaginatorEvent>();
	@Output()
	onPageSizeSelectChanged = new EventEmitter<PageSizeEvent>();

	currentPage = 1;

	options;
	model: number;
	private _activePage = 1;

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	get pageDisplay() {
		// set the max page numbers displayed between the first and last page numbers
		const maxDisplay = 5;
		let pageArr = [];

		// check if the number of pages goes beyond the max displayed pages (including the first and last page)
		if (this.totalPages <= maxDisplay + 2) {
			for (let i = 1; i <= this.totalPages; i++) {
				pageArr.push(i);
			}

			return pageArr;

			// if there are more pages than the max display, then add a page mask
		} else {
			// if displaying one page mask at the end of the paginator
			if (this.currentPage <= maxDisplay - 1) {
				for (let i = 1; i < maxDisplay; i++) {
					pageArr.push(i + 1);
				}
				pageArr = [...pageArr, null];

				// if displaying one page mask at the front of the paginator
			} else if (this.currentPage > this.totalPages - maxDisplay + 1) {
				const endPage = this.totalPages - maxDisplay;
				for (let i = 1; i < maxDisplay; i++) {
					pageArr.push(endPage + i);
				}
				pageArr = [null, ...pageArr];

				// if we need 2 page masks
			} else {
				let middlePages = [];
				const middle = Math.round((maxDisplay - 2) / 2);

				// loop though the middle pages (minus the page masks)
				// to determine the pages to be placed before and after the middle page
				for (let i = 1; i <= maxDisplay - 2; i++) {
					if (i < middle) {
						middlePages.push(this.currentPage - (middle - i));
					} else if (i > middle) {
						middlePages.push(this.currentPage + (i - middle));
					} else {
						middlePages.push(this.currentPage);
					}
				}

				pageArr = [null, ...middlePages, null];
			}

			// add the generated pages between the first and total pages
			return [1, ...pageArr, this.totalPages];
		}
	}

	displayOptions() {
		return this.paginationDisplay.map((n, i) => {
			this.paginationDisplayPreselected = this.paginationDisplayPreselected ? this.paginationDisplayPreselected : this.paginationDisplay[0]
			return {
				label: n + "",
				value: n + "",
				selected: true ? i === this.paginationDisplayPreselected : false
			};
		});
	}

	ngOnInit() {
		if (this.activePage && this.activePage > 0 && this.activePage <= this.totalPages) {
			this.currentPage = this.activePage;
		}
		this.options = this.displayOptions();
	}

	$_Paginator_onFirstPageButtonClicked() {
		this.currentPage = 1;
		this.onPaginatorButtonClicked.emit({ pageNumber: 1 });
	}

	// On the previous page button clicked
	$_Paginator_onPreviousPageButtonClicked() {
		// If current page is not the first page, currentPage--
		if (this.currentPage > 1) {
			this.currentPage--;
		}

		// Emit the onPaginatorButtonClicked event
		this.onPaginatorButtonClicked.emit({ pageNumber: this.currentPage });
	}

	// On the next page button clicked
	$_Paginator_onNextPageButtonClicked() {
		// If current page is not the last page, currentPage++
		if (this.currentPage < this.totalPages) {
			this.currentPage++;
		}

		// Emit the onPageinatorButtonClicked event
		this.onPaginatorButtonClicked.emit({ pageNumber: this.currentPage });
	}

	// On the page number button clicked
	$_Paginator_onPageNumberButtonClicked(val) {
		// Reset current page based on the clicked button's number
		if (val) {
			this.currentPage = val;
		}

		// Emit the onPaginatorButtonClicked event
		this.onPaginatorButtonClicked.emit({ pageNumber: this.currentPage });
	}

	// On the last page button clicked
	$_Paginator_onLastPageButtonClicked() {
		// Reset current page to the last page
		this.currentPage = this.totalPages;

		// Emit the onPaginatorButtonClicked event
		this.onPaginatorButtonClicked.emit({ pageNumber: this.totalPages });
	}

	// On the page size select changed
	$_Paginator_onPageSizeSelectChange(e) {
		// Reset current page to the first page
		this.currentPage = 1;
		this.paginationDisplayPreselected = e;
		if (!e.value) {
			this.onPageSizeSelectChanged.emit({
				currentPage: this.currentPage,
				pageSize: e
			});
		} else {
			// Emit the onPageSizeSelectChanged event
			this.onPageSizeSelectChanged.emit({
				currentPage: this.currentPage,
				pageSize: parseInt(e, 10)
			});
		}

	}
}
